/* Change this file to get your personal Porfolio */

const theme = {
  primaryTheme: "#6C63FF",
  secondaryTheme: "#55198b",
  easing: "cubic-bezier(0.645, 0.045, 0.355, 1)"
};

const greeting = {
	/* Your Summary And Greeting Section */
	//title: "Hi all 👋 I'm PINAKI",
	title: "PINAKI SEN",
	nickname: "pinaki_sen",
	// subTitle:
	//   "A passionate Full Stack Software Developer 🚀 having an experience of building Web and Mobile applications with JavaScript / Reactjs / Nodejs / React Native and some other cool libraries and frameworks",
	subTitle:
		"Learning to teach Machines to learn, but not in a classical way. Exploring the world of Qubits. Interested in Autonomous driving.",
	resumeLink:
		"https://drive.google.com/file/d/1EKjnWWXhiQzL3FAHVTRlaNjjfJAVbvPJ/view?usp=sharing"
};

const socialMediaLinks = {
	/* Your Social Media Link */
	github: "https://github.com/senpinaki222",
	linkedin: "https://www.linkedin.com/in/senpinaki222/",
	gmail: "pinakisen.eenita@gmail.com",
	gitlab: "https://gitlab.com",
	facebook: "https://www.facebook.com/senpinaki222",
	twitter: "https://twitter.com/pinaki_sen_",
	instagram: "https://www.instagram.com/pinaki_sen_/"
};

const skills = {
  data: [
    {
      title: "Quantum Computing and QCA",
      imagePath: "qca.gif",
      skills: [
        "⚡ Exploring Quantum Computing, especially focused in the domain of QML",
        "⚡ Experience in Quantum circuit simulation frameworks - Qiskit, Pennylane",
        "⚡ Research Experience on Systematic cell placement algorithm for digital logic circuits on QCA",
        "⚡ Experience of designing basic logic gates on Quantum dot Cellular Automata",
      ],
      softwareSkills: [
        {
          skillName: "QC",
          fontAwesomeClassname: "",
          style: {
            color: "#FF2BC2"
          }
        }
      ]
    },
    {
      title: "Machine Learning",
      imagePath: "data_science.svg",
      skills: [
        "⚡ Developing Deep Learning Model using Tensorflow & Keras",
        "⚡ Developing Python Library for Deep Learning",
        "⚡ Developing Machine Learning Model using scikit-learn",
        "⚡ Experience of Data visualization and Data Plotting",
        "⚡ Experience of working with Computer Vision using openCV",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent"
          }
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000"
          }
        },
        {
          skillName: "Matplotlib",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent"
          }
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB"
          }
        }
      ]
    },
    {
      title: "Full Stack Development",
      imagePath: "fullstack.svg",
      skills: [
        "⚡ Building Full Stack e-commerce Website using MERN Stack",
        "⚡ Building Resposive website front end using ReactJs",
        "⚡ Creating application backend in Node, Express, mongoDB",
        "⚡ Experience of working with Django, PostgreSQL"
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26"
          }
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6"
          }
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E"
          }
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB"
          }
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933"
          }
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248"
          }
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791"
          }
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837"
          }
        }
      ]
    }
    
  ]
};

const competitiveSites = {
  competitiveSites: [
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866"
      },
      profileLink: "https://www.hackerrank.com/senpinaki222"
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754"
      },
      profileLink: "https://www.hackerearth.com/@senpinaki222"
    },
    {
      siteName: "Interviewbit",
      iconifyClassname: "simple-icons:interviewbit",
      style: {
        color: "#323754"
      },
      profileLink: "https://www.interviewbit.com/profile/pinaki_sen"
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF"
      },
      profileLink: "https://www.kaggle.com/senpinaki222"
    }
  ]
}

const degrees = {
  degrees : [
    {
      title: "National Institute of Technology, Agartala",
      subtitle: "B.Tech. in Electrical Engineering",
      logo_path: "nita_logo.png",
      alt_name: "NIT Agartala",
      duration: "2018 - Present",
      descriptions: [
        "⚡ I have studied basic Electrical Engg. subjects - Network Analysis, Digital Electronics, Electrical Machines, Analog Electronics etc.",
        "⚡ I have knowledge of Data Structure & Algorithm, Object oriented programming as a part of course work"
      ],
      website_link: "https://www.nita.ac.in/"
    }
  ]
}

const certifications = {
	certifications: [
    {
			title: "Certificate of Quantum excellence, Qiskit Global Summer School",
			subtitle: "- IBM Quantum",
			logo_path: "qiskit_logo.png",
			certificate_link:
				"https://drive.google.com/file/d/181MIgp9yJIZBtD-3EG9rttVbcFmtU7kp/view?usp=sharing",
			alt_name: "IBM Quantum",
			color_code: "#2C3335"
    },
    {
			title: "Machine Learning, Stanford Online, Coursera",
			subtitle: "- Prof. Andrew Ng",
			logo_path: "stanford_logo.png",
			certificate_link:
				"https://www.coursera.org/account/accomplishments/certificate/QATZCDNYDGD5",
			alt_name: "Coursera",
			color_code: "#758AA2"
    },
    {
			title: "Neural Networks and Deep Learning, deeplearning.ai, Coursera",
			subtitle: "- Prof. Andrew Ng",
			logo_path: "deeplearning_ai_logo.png",
			certificate_link:
				"https://www.coursera.org/account/accomplishments/certificate/ACRVUCJX82S9",
			alt_name: "Coursera",
			color_code: "#A4B0BD"
    },
    {
			title: "Introduction to Tensorflow for Artificial Intelligence, deeplearning.ai, Coursera",
			subtitle: "- Laurence Moroney, Google Brain",
			logo_path: "deeplearning_ai_logo.png",
			certificate_link:
				"https://www.coursera.org/account/accomplishments/certificate/XWQZTR8YZMXM",
			alt_name: "Coursera",
			color_code: "#A4B0BD"
    },
    {
			title: "Introduction to Self-Driving Cars, University of Toronto, Coursera",
			subtitle: "- Steven Waslander, Associate Professor",
			logo_path: "toronto_logo.jpg",
			certificate_link:
				"https://www.coursera.org/account/accomplishments/certificate/P66PCWMTKEQ4",
			alt_name: "Coursera",
			color_code: "#2B2B52"
    },
    {
			title: "Python Certification",
			subtitle: "- Hackerrank",
			logo_path: "hackerrank_logo.png",
			certificate_link:
				"https://www.hackerrank.com/certificates/335d8df165f1",
			alt_name: "Hackerrank",
			color_code: "#A4B0BD"
		},
		{
			title: "Machine Learning Fundamental with Python track",
			subtitle: "- Datacamp",
			logo_path: "datacamp_logo.png",
			certificate_link:
				"https://www.datacamp.com/statement-of-accomplishment/track/83b0070854c6c03daa4e8fbcacb1b2baae7239d9",
			alt_name: "Datacamp",
			color_code: "#30336B"
		},
		
    {
			title: "Problem Solving (Basic) Certification",
			subtitle: "- Hackerrank",
			logo_path: "hackerrank_logo.png",
			certificate_link:
				"https://www.hackerrank.com/certificates/84fc3ba4f130",
			alt_name: "Hackerrank",
			color_code: "#A4B0BD"
		},
    {
			title: "Introduction to Deep Learning with Keras",
			subtitle: "- Datacamp",
			logo_path: "datacamp_logo.png",
			certificate_link:
				"https://www.datacamp.com/statement-of-accomplishment/course/7a801839fe84f69cce9d15e603fce82140564456",
			alt_name: "Datacamp",
			color_code: "#30336B"
    },
    {
			title: "Full Stack Development using MERN",
			subtitle: "- Hitesh Choudhary",
			logo_path: "lco_logo.png",
			certificate_link:
				"https://drive.google.com/file/d/1gBU97TfKeWzx3XqkwUo24gZ6U-sPb28w/view",
			alt_name: "LearnCodeOnline",
			color_code: "#30336B"
    },
    {
			title: "MATLAB Onramp",
			subtitle: "- MATLAB",
			logo_path: "matlab_logo.png",
			certificate_link:
				"https://matlabacademy.mathworks.com/progress/share/report.html?id=7117aba0-3a13-48fa-aa05-73244933fbe0",
			alt_name: "MATLAB",
			color_code: "#0A79DF"
    },
    {
			title: "AWS Machine Learning Foundations Course",
			subtitle: "- Udacity",
			logo_path: "udacity_logo.jpg",
			certificate_link:
				"https://s3-us-west-2.amazonaws.com/udacity-printer/production/certificates/4ac936e6-082f-4aeb-900a-c84cf78d3057.pdf?utm_campaign=sch_600_auto_ndxxx_aws-ml-completed_global&utm_source=blueshift&utm_medium=email&utm_content=sch_600_auto_ndxxx_aws-ml-complet",
			alt_name: "Udacity",
			color_code: "#47535E"
    },
    {
			title: "Aerial Robotics, University of Pennsylvania, Coursera",
			subtitle: "- Prof. Vijay Kumar",
			logo_path: "upenn_logo.png",
			certificate_link:
				"https://www.coursera.org/account/accomplishments/certificate/TL6KPQK59RGJ",
			alt_name: "Udacity",
			color_code: "#EAF0F1"
    },
		{
			title: "Simulink Onramp",
			subtitle: "- MATLAB",
			logo_path: "simulink_logo.jpg",
			certificate_link:
				"https://matlabacademy.mathworks.com/progress/share/report.html?id=866b320d-eb81-4a52-b7cb-ae6818bc15fd",
			alt_name: "MATLAB",
			color_code: "#EAF0F1"
		}
	]
};

const openSource = {
  /* Your Open Source Section to View Your Github Pinned Projects */
  /* To know how to get github key look at readme.md */

  githubConvertedToken: "",
  githubUserName: "senpinaki222"
};

const bigProjects = {
  /* Some Big Projects You have worked with your company */
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELP TO CREATE THEIR TECH",
  projects: [
    {
      image: "",
      link: ""
    },
    {
      image: "",
      link: ""
    }
  ]
};

const achievementSection = {
  /* Your Achievement Section Include Your Certification Talks and More */

  title: "Achievements And Certifications 🏆 ",
  subtitle:
    "Achievements, Certifications Award Letters and Some Cool Stuff that i have done !",

  achivementsCards: [
    {
      title: "Discovery Challange, InterviewBit",
      description:
        "Achieved second position among NIT Agartala students in Discovery challenge, a coding competition organized by InterviewBit all over India",
      image:
        "",
      footerLink: [
        {
          name: "Certification",
          url:
            "https://drive.google.com/file/d/1picXYE4Gi57W8dR43oO7AllwkE89Tkmb/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url:
            ""
        },
        {
          name: "Google Code-in Blog",
          url:
            ""
        }
      ]
    },
    {
      title: "Flipkart GRID 2.0",
      description:
        "Among top 20 teams in NIT Agartala campus in the first round of Flipkart Grid 2.0",
      image:
        "",
      footerLink: [
        {
          name: "",
          url:
            "https://drive.google.com/file/d/1ptTIOH4sxEIPF97tWwrdgAzNyfTkW--X/view?usp=sharing"
        }
      ]
    },

    {
      title: "",
      description:
        "",
      image:
        "",
      footerLink: [
        { name: "Certification", url: "" },
        {
          name: "Final Project",
          url: ""
        }
      ]
    }
  ]
};

const blogSection = {
  /* Blogs Section */

  title: "Blogs",
  subtitle:
    "",
  link: "",
  avatar_image_path: "blogs_image.svg"

  
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅",

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/",
      image:
        "https://scontent.fkhi6-1.fna.fbcdn.net/v/t1.0-9/76714032_1730516240415559_1293494289556307968_o.jpg?_nc_cat=103&_nc_ohc=s5f81rdZd6wAQmqUa52YQBA21MjVOy7e-HN9jI7MspRDC-v5ahEouyInQ&_nc_ht=scontent.fkhi6-1.fna&oh=c29141a9a0de7ff2011a8191f5475a78&oe=5E83127C"
    }
  ]
};

// Podcast Section
const podcastSection = {
  title: "Podcast 🎙️",
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    ""
  ]
};

const contactInfo = {
  title: "Contact Me ☎️",
  subtitle: "Discuss a project or just want to say hi my inbox is open for all",
  number: "+91-8617788985",
  email_address: "pinakisen.eenita@gmail.com"
};

export {
	theme,
	greeting,
	socialMediaLinks,
	skills,
	competitiveSites,
	degrees,
	certifications,
	openSource,
	bigProjects,
	achievementSection,
	blogSection,
	talkSection,
	podcastSection,
	contactInfo
};
